import Project from "../project/project.model";
import TicketStatusStat from "../ticket-status-stat/ticket-status-stat.model";
import User from "../user/user.model";

export default class ProjectStat {
    public user: User = new User();
    public project: Project = new Project();
    public ticketStatusStats: TicketStatusStat[] = [];
    public from: Date = new Date(0);
    public to: Date = new Date(0);
    /**
     * @param {any} model - It is possible to pass an object to the constructor.
     * If the proper attributes are filled and exist, the constructor will set up the
     * new instance with the provided values.
     */
    constructor(model: any = null) {
        if (model) {
            this.fill(model);
        }
    }

    /**
     * Fills the instance attributes from the given object if the necessary properties
     * are set up and available.
     */
    private fill(model: any) {
        if (model.user) {
            this.user = new User(model.user);
        }
        if (model.project) {
            this.project = new Project(model.project);
        }
        if (model.ticketStatusStats) {
            this.ticketStatusStats = [];
            for (let i = 0; i < model.ticketStatusStats.length; i++) {
                this.ticketStatusStats.push(new TicketStatusStat(model.ticketStatusStats[i]));
            }
        }
        if (model.from) {
            this.from = new Date(model.from);
        }
        if (model.to) {
            this.to = new Date(model.to);
        }
    }
}